import { useEffect } from "react";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import NotFoundHeader from "../components/NotFoundHeader";

function NotFound() {
    useEffect(() => {
        document.title = "Página no encontrada";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-4 md:px-10 pt-2 pb-8 md:pb-10">
                <NotFoundHeader />
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default NotFound;
